import React from "react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import BdrModal from "../../../../components/BdrModal/BdrModal";
import BdrButton from "../../../../components/BdrButton/BdrButton";
import "./emailConfirmModal.css";

// Destructive-confirm modal for email delete / block. Both actions permanently
// delete the email(s) AND cascade-delete their attached photos/PDFs that aren't
// referenced elsewhere — so this warns about the finality and forces an
// explicit confirm.
//
// Optional second choice (the Archived view's "whole thread", D19): pass
// `secondaryLabel` + `onSecondary`. `tone="neutral"` is the non-destructive
// Restore chooser (no warning icon, no red). Callers that pass neither render
// exactly as before.
const EmailConfirmModal = ({
  open,
  title,
  message,
  confirmLabel = "Delete",
  secondaryLabel,
  secondaryDisabled,
  onSecondary,
  tone,
  busy,
  onCancel,
  onConfirm,
}) => {
  const neutral = tone === "neutral";
  // Both commits are explicit choices in an already-confirming modal, so
  // `confirm={false}` — a `danger` BdrButton would otherwise stack its own
  // "Are you sure?" over this one. Each handler is wrapped: BdrButton passes
  // the click event, which must never reach a handler as an argument.
  const commitVariant = neutral ? "action-solid" : "danger";
  return (
    <BdrModal
      open={!!open}
      onClose={busy ? () => {} : onCancel}
      closeOnBackdrop={!busy}
      closeOnEsc={!busy}
      variant="panel"
      size="md"
      showHeader={false}
      ariaLabel={typeof title === "string" ? title : "Confirm"}
      /* peak: the inbox can already have a modal open over it, so this
         takes the highest rung. */
      layer="peak"
      actions={
        <>
          <BdrButton disabled={busy} onClick={onCancel}>
            Cancel
          </BdrButton>
          {secondaryLabel && (
            <BdrButton
              variant={commitVariant}
              confirm={false}
              disabled={busy || secondaryDisabled}
              onClick={() => onSecondary?.()}
            >
              {secondaryLabel}
            </BdrButton>
          )}
          <BdrButton variant={commitVariant} confirm={false} disabled={busy} onClick={() => onConfirm?.()}>
            {busy ? "Working..." : confirmLabel}
          </BdrButton>
        </>
      }
    >
      <h3 className="email-confirm-title">
        {!neutral && <WarningAmberIcon className="email-confirm-icon" />}
        {/* Its own flex item on purpose: a bare text node can't take
            min-width, and a flex item's default min-width:auto refuses to
            shrink below its content's min-content width — which for an
            address like matt+businessdebtstrategies.com@ec1.msgsndr.org blew
            past the panel and produced horizontal scroll. `anywhere` (not
            `break-word`) is required: only `anywhere` also shrinks the
            min-content size, which is what stops the flex overflow. */}
        <span className="email-confirm-title-text">{title}</span>
      </h3>
      <p className="email-confirm-message">{message}</p>
    </BdrModal>
  );
};

export default EmailConfirmModal;
